import { useLocation } from 'react-router-dom';

import { useModals } from '@/router';

export default function AppModal() {
  const location = useLocation();
  const modals = useModals();

  const handleClose = () => modals.close();

  return (
    <div>
      <div onClick={handleClose} />
      <div>
        <h2>Global Modal!</h2>
        <p>{`Current pathname: ${location.pathname}`}</p>
        <button onClick={() => modals.close()} type="button">
          Close
        </button>
      </div>
    </div>
  );
}
